import React, {useState, useEffect} from 'react';

import {Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";


import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import AuthService from "../util/AuthService";
import "react-loading-skeleton/dist/skeleton.css";


import FullCalendarDuty from "./FullCalendarDuty";

const DutyCalendarPage = () => {


    document.title = "Dashboard | Plantão Rápido";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Calendário" pageTitle="Plantão"/>
                    <Row>
                            <>
                                {/* Adiciona o componente de carrossel na página principal */}
                                <div className="row">

                                    <FullCalendarDuty />
                                </div>
                            </>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DutyCalendarPage;
